var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (notification, notification_class, read_class) {
      read_class = notification.read ? "" : "activity-item--unread"
notification_class = read_class + " ga__notification-following-"+notification.trackable.type
pug_html = pug_html + "\u003Cli class=\"activity-item\"\u003E\u003Ca" + (pug.attr("class", pug.classes(["activity-item__link",notification_class], [false,true]), false, true)+pug.attr("href", notification.trackable.url, true, true)+pug.attr("data-title", notification.trackable.title, true, true)) + "\u003E";
if (notification.owner.default_avatar) {
pug_html = pug_html + "\u003Cdiv class=\"activity-item__initial avatar-initial\"\u003E" + (pug.escape(null == (pug_interp = notification.owner.initial) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (" class=\"activity-item__avatar\""+pug.attr("src", notification.owner.avatar_url, true, true)+" width=\"35\" height=\"35\"") + "\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"activity-item__container\"\u003E\u003Cdiv class=\"activity-item__message\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = notification.owner.display_name) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003Cspan\u003E&nbsp;\u003C\u002Fspan\u003E" + (null == (pug_interp = notification.message) ? "" : pug_interp) + "\u003Cspan\u003E&nbsp;\u003C\u002Fspan\u003E";
if (notification.trackable) {
pug_html = pug_html + "\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = notification.trackable.title) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }.call(this, "notification" in locals_for_with ?
        locals_for_with.notification :
        typeof notification !== 'undefined' ? notification : undefined, "notification_class" in locals_for_with ?
        locals_for_with.notification_class :
        typeof notification_class !== 'undefined' ? notification_class : undefined, "read_class" in locals_for_with ?
        locals_for_with.read_class :
        typeof read_class !== 'undefined' ? read_class : undefined));
    ;;return pug_html;};
module.exports = template;